import { yupResolver } from "@hookform/resolvers/yup";
import img from "../../../assets/images/InceptionFinicallyLogo.png";
import { colors } from "../../../utils/theme";
import Button from "../../Button";
import CustomButton from "../../Button/CustomButton";
import CustomInput from "../../CustomInput";
import styles from "./index.module.css";
import { useForm } from "react-hook-form";
import { forgotPasswordSchema } from "../../../yup";
import { useEffect, useState } from "react";
import { config } from "../../../configs/index";
import { showNotification } from "../../../services/showNotification";
import { useResetPasswordMutation } from "../../../services/epcApi";

const ForgotPassword = () => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(forgotPasswordSchema),
  });
  const [errMsg, setErrMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [resetPassword] = useResetPasswordMutation();

  const onSubmit = async (values: any) => {
    try {
      setIsLoading(true);
      const result = await resetPassword(values).unwrap();

      if (result.data.status === 400) {
        setErrMsg("Email is invalid");
        showNotification("error", "Please try again with a valid Email.");
        return;
      }
      showNotification("success", "Reset password link sent to you Email.");
      reset();
      setErrMsg("");
    } catch (error) {
      console.log(error, "err----");
    } finally {
      setIsLoading(false);
    }
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setValue(name as "email", value);
    setErrMsg("");
  };

  return (
    <div className={styles.customClass}>
      <div className={styles.content}>
        <div className="w-full flex items-center justify-center">
          <div className="w-[80vw] h-[80vh] relative flex flex-col items-center justify-center  ">
            <div className=" flex justify-start px-10 pb-20 absolute top-0 left-0">
              <img src={img} alt="" className={`${styles.image}`} />
            </div>
            <form
              className="flex flex-col h-1/2 w-full md:w-1/2 items-center justify-center"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="w-[70%]">
                <CustomInput
                  placeholder="Email"
                  name="email"
                  type="email"
                  register={register}
                  error={errors.email}
                  onChange={onChange}
                />
              </div>
              {/* <div className="w-[70%]">
                <CustomInput
                  placeholder="New Password"
                  name="newPassword"
                  type="password"
                  register={register}
                  error={errors.newPassword}
                />
              </div> */}
              {/* <div className="w-[70%]">
                <CustomInput
                  placeholder="Repeat Password"
                  name="repeatPassword"
                  type="password"
                  register={register}
                  error={errors.repeatPassword}
                />
              </div> */}
              <div className="w-[70%]">
                {errMsg && (
                  <p className="text-red-500 font-bold text-md">{errMsg}</p>
                )}
              </div>

              <div className="flex flex-col items-center justify-center md:block w-[70%] mt-8">
                <CustomButton
                  buttonLabel="Reset password"
                  isLoading={isLoading}
                />
              </div>
              <span
                className={`text-[${colors.green}] font-normal w-1/2 flex items-center justify-center  sm:text-[16px] text-[14px] `}
              >
                Cancel and back to{" "}
                <a href={"/epc"} className=" ml-2 underline">
                  Login
                </a>
              </span>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
